import { render } from "./GeneralLayout.vue?vue&type=template&id=1307b58c"
import script from "./js/generalLayout.js?vue&type=script&lang=js&external"
export * from "./js/generalLayout.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__